import { render, staticRenderFns } from "./EditAssessment.vue?vue&type=template&id=1f1fa957&scoped=true"
import script from "./EditAssessment.vue?vue&type=script&lang=js"
export * from "./EditAssessment.vue?vue&type=script&lang=js"
import style0 from "./EditAssessment.vue?vue&type=style&index=0&id=1f1fa957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1fa957",
  null
  
)

export default component.exports